import TwoColumnTemplateLayout, { TwoColumnTemplateLayoutProps } from './TwoColumnTemplateLayout';

export function TwoColumnRightTemplateLayout(props: TwoColumnRightTemplateLayoutProps) {
    return <TwoColumnTemplateLayout {...props} columnPosition={'right'} />;
}

export type TwoColumnRightTemplateLayoutProps = Omit<TwoColumnTemplateLayoutProps, 'columnPosition'>;

export default TwoColumnRightTemplateLayout;
